import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Anulom = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Anulom.title1"), context: t("Anulom.context1") },
      { title: t("Anulom.title2"), context: t("Anulom.context2") },
      { title: t("Anulom.title3"), context: t("Anulom.context3") },
      { title: t("Anulom.title4"), context: t("Anulom.context4") },
      { title: t("Anulom.title5"), context: t("Anulom.context5") },
      { title: t("Anulom.title6"), context: t("Anulom.context6") },
      { title: t("Anulom.title7"), context: t("Anulom.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Anulom.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/Anulom+Vilom.mp4'}
                title="Description"
                context={t("Anulom.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Anulom
